module.exports = __webpack_public_path__ + "static/media/042-vampire.9118dbf9.svg";